import { SET_CLIENT_METADATA } from 'root/src/client/logic/app/actionIds'

export default clientMetadata => ({
	type: SET_CLIENT_METADATA,
	payload: clientMetadata,
})
